

<div class="container">
  <div>
    <div class="custom-row" *ngIf="isUserLoggedIn; else notLoggedIn">
      <div class="custom-column-left">
        <app-profile-list></app-profile-list>
      </div>
      <div class="custom-column-right">
        <router-outlet></router-outlet>
      </div>
    </div>

    <ng-template #notLoggedIn>
      <p>Please log in to access this content.</p>
    </ng-template>
  </div>
</div>